export default "__VITE_ASSET__CwoiW0tt__"